// IconRenderer.jsx

import React from "react";

// React icons
import { MdHomeFilled } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import {
  PiCreditCardLight,
  PiIdentificationCard,
  PiQuestionBold,
  PiGraduationCap,

} from "react-icons/pi";

// Image imports
import reg from "../../src/assets/images/sidebar/registration.svg";
import scorecard from "../../src/assets/images/sidebar/score card.svg";
import objection from "../../src/assets/images/sidebar/objection-tracker.svg";
import reghover from "../../src/assets/images/sidebar/registration-active.svg";
import scorecardhover from "../../src/assets/images/sidebar/score card-active.svg";
import objectionhover from "../../src/assets/images/sidebar/objection-tracker-active.svg";
import checklist from "../../src/assets/images/sidebar/checklist.png";
import survey from "../../src/assets/images/sidebar/survey.png";
import user from "../../src/assets/images/sidebar/user.png";
import bell from "../../src/assets/images/sidebar/bell-school.png";
import credit from "../../src/assets/images/sidebar/creditcard.png";
import doubts from "../../src/assets/images/sidebar/doubts-button.png";
import idBadge from "../../src/assets/images/sidebar/id-badge.png";
import idCard from "../../src/assets/images/sidebar/id-card.png";

// Map of icon components
const iconMap = {
  MdHomeFilled,
  CgProfile,
  PiCreditCardLight,
  PiIdentificationCard,
  PiQuestionBold,
  PiGraduationCap,
};

// Map of base image icons
const imageMap = {
  reg,
  scorecard,
  objection,
  checklist,
  survey,
  user,
  bell,
  credit,
  doubts,idBadge,
  idCard
};

// Map of hover variants
const hoverImageMap = {
  reg: reghover,
  scorecard: scorecardhover,
  objection: objectionhover,
};

const IconRenderer = ({
  iconName,
  color,
  backgroundColor,
  filter,
  named,
  height,
  width,
  isHover,
}) => {
  const IconComponent = iconMap[iconName];
  const commonStyle = {
    ...(color && { color }),
    ...(backgroundColor && { backgroundColor }),
    ...(filter && { filter }),
    ...(height && { height }),
    ...(width && { width }),
  };

  // ✅ If it's a React Icon
  if (IconComponent) {
    return <IconComponent size={named === "Home" ? 100 : 24} style={commonStyle} />;
  }

  // ✅ If it's an image name and hover version exists
  const resolvedImage =
    isHover && hoverImageMap[iconName]
      ? hoverImageMap[iconName]
      : imageMap[iconName] || iconName;

  return <img src={resolvedImage} alt={iconName} style={commonStyle} />;
};

export default IconRenderer;
